export const fetchCurrency = {
  CNY: '￥',
  USD: '$',
  EUR: '€',
  INR: '₹'
}

export const fetchCurrencyByCulture = {
  zh: '￥',
  en: '$',
  id: '₹'
}

export const countryCodeList = [
  {
    label: '+91 India',
    value: '91'
  },
  {
    label: '+61 Australia',
    value: '61'
  },
  {
    label: '+64 New Zealand',
    value: '64'
  },
  {
    label: '+971 UAE',
    value: '971'
  }
]

export const MessageStatus = {
  Undefined: 0,
  Unread: 1,
  Read: 2
}

export const MessageCategory = {
  Personal: 0,
  Event: 1,
  System: 2
}
/***
 * 获取指定国家的身份证正则表达式
 * @type {{getReg: (function(*): RegExp)}}
 */
export const InternationIDCardReg = {
  getReg: function (internation) {
    let reg = RegExp(/^\d{12}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^\d{12}$/)
        break
      case 'INT':
        reg = RegExp(/^\d{12}$/)
        break
      case 'VN':
        reg = RegExp(/^(\d{9}|\d{12})$/)
        break
    }
    return reg
  }
}
/***
 * 获取指定国家的银行账号正则表达式
 * @type {{getReg: (function(*): RegExp)}}
 */
export const InternationAccountNumberReg = {
  getReg: function (internation) {
    let reg = RegExp(/^\d{8,18}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^\d{8,18}$/)
        break
      case 'INT':
        reg = RegExp(/^\d{8,18}$/)
        break
      case 'VN':
        reg = RegExp(/^\d{8,18}$/)
        break
    }
    return reg
  }
}
/****
 * 获取指定国家的银行列表
 * @type {{getBankList: InternationBankList.getBankList}}
 * 2022-02-17 CHP 创建
 */
export const InternationBankList = {
  getBankList: function (internation) {
    let bankList = []
    switch (internation) {
      case 'VN':
        bankList = [
          {
            code: 'AGR',
            name: 'AGRIBANK'
          },
          {
            code: 'BIDV',
            name: 'BIDV BANK'
          },
          {
            code: 'EIB',
            name: 'EXIMBANK'
          },
          {
            code: 'GPB',
            name: 'GP BANK'
          },
          {
            code: 'HDB',
            name: 'HD BANK'
          },
          {
            code: 'MB',
            name: 'MBBANK'
          },
          {
            code: 'NAB',
            name: 'NAMA BANK'
          },
          {
            code: 'ACB',
            name: 'NGAN HANG A CHAU'
          },
          {
            code: 'VAB',
            name: 'VAB BANK'
          },
          {
            code: 'OJB',
            name: 'OCEANBANK'
          },
          {
            code: 'PGB',
            name: 'PGBANK'
          },
          {
            code: 'OCB',
            name: 'PHUONGDONG BANK'
          },
          {
            code: 'STB',
            name: 'SACOMBANK'
          },
          {
            code: 'SGB',
            name: 'SAIGONBANK'
          },
          {
            code: 'SCB',
            name: 'SCB'
          },
          {
            code: 'SHB',
            name: 'SHB BANK'
          },
          {
            code: 'TCB',
            name: 'TECHCOMBANK'
          },
          {
            code: 'TPB',
            name: 'TIENPHONG BANK'
          },
          {
            code: 'VIB',
            name: 'VIB BANK'
          },
          {
            code: 'VCB',
            name: 'VIETCOMBANK'
          },
          {
            code: 'CTG',
            name: 'VIETINBANK'
          },
          {
            code: 'VPB',
            name: 'VPBANK'
          },
          {
            code: 'ABB-K',
            name: 'ABBANK'
          },
          {
            code: 'Dong',
            name: 'DongABank'
          }
        ]
        break
    }
    return bankList
  }
}
/****
 * 获取指定国家的IFSC验证表达式
 * @type {{getReg: InternationIFSCReg.getReg}}
 */
export const InternationIFSCReg = {
  getReg: function (internation) {
    let reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
    switch (internation) {
      case 'IN':
        reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
        break
      case 'INT':
        reg = RegExp(/^[A-Za-z]{4}[0]\w{6}$/)
        break
      case 'VN':
        reg = RegExp(/[\w-]+$/)
        break
    }
    return reg
  }
}
// For log web visit
export const VisitType = {
  Visit: 'Visit',
  Deposit: 'Deposit',
  Withdraw: 'Withdraw',
  PlayGame: 'PlayGame'
}



// WEBPACK FOOTER //
// ./src/constant.js